import React, { Component } from "react";
import FlexView from "react-flexview";
import * as R from "ramda";
import { monthOptions, yearOptions } from "../../config";
import { configYearToDate } from "../config";
import { removeNullFields } from "../../../../../common/mapper";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import SimpleUploadImage from "../../../../../../modules/upload/SimpleUploadImage";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import Api from "../../../../../../Services/Api";
import { HttpStatus } from "../../../../../common/Constants";
import { service } from '../service'
import CardBiaxialChart from "../../../../../../cards/BiaxialChart";

class ROYearToDateH1Report extends Component {
    constructor(props) {
        super(props);
        this.state = {
            month: null,
            year: null,
            tableConfig: [],
            dataTable: [],
            chartVisible: false,
            dataChartVolume: [],
            dataChartRate: [],
        };
    };

    componentDidMount() {
        let currentDate = new Date();
        this.setState((prevValue) => ({
            ...prevValue,
            // month: monthOptions.find((item) => item.value === currentDate.getMonth()),
            month: monthOptions.find(
              (item) => item.value === currentDate.getMonth() + 1
            ),
            year: yearOptions.find(
                (item) => item.value === currentDate.getFullYear()
            ),
            tableConfig: [
                { name: "namaCabang", label: "Nama Cabang", options: { sort: false } },
                ...configYearToDate,
            ],
        }));
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!R.equals(prevProps.search, this.props.search)) {
            this.fetchData();
        }
    };

    handleChangeSearchValue = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
        }));
    };

    filterKeys = (data, include = false) => {
        return data.map(item => {
            const newItem = {};
            for (const key in item) {
                const hasKeyword = key.toLowerCase().includes('rate');
                if ((include && (hasKeyword || key === "namaCabang")) || (!include && !hasKeyword)) {
                    newItem[key] = item[key];
                }
            }
            return newItem;
        });
    };

    fetchData = async () => {
        try {
            this.props.triggerLoading();
            let dataKodeCabang = this.props.search;
            if (this.props.isAllSelected) {
                dataKodeCabang = this.props.dataCabang.map((item) => item.kodeCabang);
            }
            const res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanStatistikROCrossSellingYTDROH1,
                setError: this.props.setError,
                menuName: "Dashboard Kacab Admin CRM - Laporan Statistik Repeat Order H1 per Cabang Year To Date",
                args: {
                    kodeCabangList: dataKodeCabang,
                    year: this.state.year?.value,
                    // month: this.state.month.value,
                },
            });
            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                this.setState((prev) => ({
                    ...prev,
                    dataTable: res.data.data,
                    dataChartRate: this.filterKeys(res.data.data, true),
                    dataChartVolume: this.filterKeys(res.data.data),
                }));
            }
            this.props.triggerLoading();
        } catch (error) {
            this.props.triggerLoading();
            console.log(error);
        }
    };

    handleChartVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            chartVisible: !prevValue.chartVisible,
        }));
    };

    handleSearch = () => {
        this.fetchData();
    };

    render() {
        const dataVolume = service.transformChartData(this.state.dataChartVolume);
        const dataRate = service.transformChartData(this.state.dataChartRate);
        return (
            <>
                <FlexView style={{ gap: "20px", alignItems: "center" }}>
                    <SimpleDDL
                        id="select_options_month"
                        box="search"
                        isClearable
                        name="month"
                        containerclassname="width width-250px"
                        placeholder="Bulan"
                        menuPosition="fixed"
                        options={monthOptions}
                        value={this.state.month}
                        onChange={(value, { name }) =>
                            this.handleChangeSearchValue(name, value)
                        }
                    />
                    <SimpleDDL
                        id="select_options_year"
                        box="search"
                        isClearable
                        name="year"
                        containerclassname="width width-250px"
                        placeholder="Tahun"
                        menuPosition="fixed"
                        options={yearOptions}
                        value={this.state.year}
                        onChange={(value, { name }) =>
                            this.handleChangeSearchValue(name, value)
                        }
                    />
                    <SimpleButton
                        styles={{ marginBottom: "15px" }}
                        onClick={() => this.handleSearch()}
                    >
                        Cari
                    </SimpleButton>
                </FlexView>
                {!this.state.chartVisible && (
                    <SimpleDataTable
                        data={this.state.dataTable}
                        columns={this.state.tableConfig}
                    />
                )}
                {this.state.chartVisible && (
                    <>
                        <div>
                            <div>
                                <h4>RO H1 - Volume</h4>
                                <CardBiaxialChart data={dataVolume?.data} dataKey={dataVolume?.dataKey} />
                            </div>
                            <div>
                                <h4>RO H1 - Rate</h4>
                                <CardBiaxialChart data={dataRate?.data} dataKey={dataRate?.dataKey} />
                            </div>
                        </div>
                    </>
                )}
                <FlexView style={{ justifyContent: "end", marginTop: "15px" }}>
                    <SimpleButton onClick={this.handleChartVisibility}>Chart</SimpleButton>
                </FlexView>
            </>
        );
    };
}

export default ROYearToDateH1Report;